import { Localized } from 'dg-web-shared/lib/Localization';
import { ParkingaboLink } from 'parkingabo-shared/layout/ParkinaboLink.tsx';
import { FeedbackPopup } from '../../components/FeedbackPopup';
import { useNavigate } from 'react-router';

export function RegistrationLinkExpired() {
    const navigate = useNavigate();
    return (
        <FeedbackPopup
            open
            color="error"
            onAbort={() => navigate('..')}
            abortLabel={
                <Localized de="Schliessen" fr="Fermer" it="Chiudi" en="Close" />
            }
            title={
                <Localized
                    de="Bestätigung fehlgeschlagen"
                    fr="Confirmation échouée"
                    it="Conferma non riuscita"
                    en="Confirmation failed"
                />
            }
        >
            <Localized
                de="Dieser Link ist nicht mehr gültig. Sie konnen "
                fr="Ce lien n'est plus valide. Vous pouvez demander "
                it="Questo link non è più valido. Può richiedere "
                en="This link is no longer valid. You can request "
            />
            <ParkingaboLink to={'/login'} color="error">
                <Localized
                    de="hier ein neuer Link"
                    fr="ici un nouveau lien"
                    it="qui un nuovo link"
                    en="here a new link"
                />
            </ParkingaboLink>
            <Localized de=" anfordern." fr="." it="." en="." />
        </FeedbackPopup>
    );
}
